import { FunctionComponent, useEffect, useState } from 'react';

import Box from '../../Layout/Box/Box';
import Button from '../../Input/Button/Button';
import Stepper from '../../Navigation/Stepper/Stepper';
import Title from '../../Text/Title/Title';
import BackButton from '../../Input/BackButton/BackButton';

export type MultiStepProps = {
  id: string;
  title: string;
  isPayLinkEnabled?: boolean;
  steps: {
    label: string;
    content: React.ReactNode;
    percentageComplete: (idx: number) => number;
    hasError: () => boolean;
    showStep: () => boolean;
  }[];
  stepUser?: number;
  isEmbeded?: boolean;
  isAllowMove?: boolean;
  hasBackButton?: boolean;
  onStepChange?: (stepIdx: number) => void;
  onStepReject?: (stepIdx: number) => void;
  onTeneativeSubmit?: () => void;
  handlePaylinkStep?: (e: boolean) => void;
};

type FC = FunctionComponent<MultiStepProps>;

const MultiStep: FC = ({
  id,
  steps,
  isPayLinkEnabled,
  title,
  stepUser,
  isEmbeded = false,
  isAllowMove = true,
  hasBackButton = false,
  onStepChange = () => {},
  onStepReject = () => {},
  handlePaylinkStep = () => {},
  onTeneativeSubmit = () => {},
}: MultiStepProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  const resolvedSteps = steps
    .filter(({ showStep }) => showStep())
    .map((step, idx) => ({
      ...step,
      percentageComplete: step.percentageComplete(idx),
      hasError: step.hasError(),
    }));

  const handlePrevClick = () => {
    if (isAllowMove) {
      const stepIdx = currentStep - 1;

      setCurrentStep(stepIdx);
      onStepChange(stepIdx);
    } else {
      onStepReject(currentStep);
    }
  };

  const handleNextClick = () => {
    if (isAllowMove) {
      const stepIdx = currentStep + 1;
      setCurrentStep(stepIdx);
      onStepChange(stepIdx);
    } else {
      onStepReject(currentStep);
    }
  };

  const handleStepClick = (idx: number) => {
    setCurrentStep(idx);
    onStepChange(idx);
  };

  const isFirstStep = () => currentStep === 0;
  const isLastStep = () => currentStep === resolvedSteps.length - 1;
  useEffect(() => {
    if (stepUser !== undefined) {
      setCurrentStep(stepUser);
      // onStepChange(stepUser);
    }
  }, [stepUser]);
  return (
    <div>
      {!isEmbeded && (
        <Box mb="lg" jc="fs" ai="center" gap="common">
          {hasBackButton && <BackButton variant="arrow" backButtonEnabled />}
          <Title title={title} />
        </Box>
      )}

      <Stepper steps={resolvedSteps} currentStep={currentStep} isComplete={false} onStepClick={handleStepClick} />

      <Box mt="md" jc="fe" gap="sm">
        {!isFirstStep() && (
          <Button id={`${id}-prev`} type="button" color="secondary" label="Previous" onClick={handlePrevClick} />
        )}
        {!isLastStep() && (
          <Button
            id={`${id}-next`}
            type="button"
            label="Next"
            onClick={() => {
              handleNextClick();
            }}
          />
        )}
        {!isLastStep() && isPayLinkEnabled && currentStep === 0 && (
          <Button
            id={`${id}-next`}
            type="button"
            label="Send Pay Link"
            onClick={() => {
              handleNextClick();
              handlePaylinkStep(true);
            }}
          />
        )}
        {isLastStep() && (
          <Button
            id={`${id}-submit`}
            onClick={() => {
              onTeneativeSubmit();
            }}
            type="submit"
            label="Submit"
          />
        )}
      </Box>
    </div>
  );
};

export default MultiStep;
